// extracted by mini-css-extract-plugin
export var numpadContainer = "_pq-1";
export var phoneButton = "_pq-0";